import axios from 'axios'
import env from '@/env.js'

export default axios.create({
  baseURL: env.apiUrlV1
})



// WEBPACK FOOTER //
// ./src/api/dcV1.js